<script>
import liffService from "@/services/liff";
import { claimMissYouReward, getMissYouStatus } from "@/services/missYouPromo";

const POLL_INTERVAL_MS = 3000;
const POLL_MAX_ATTEMPTS = 10;

export default {
  name: "MissYouPromo",
  data() {
    return {
      state: "loading",
      accessToken: "",
      status: null,
      claim: null,
      detailMessage: "",
      pollAttempts: 0,
      pollTimer: null,
      destroyed: false
    };
  },
  computed: {
    profile() {
      return liffService.profile || {};
    },
    displayName() {
      return this.profile.displayName || "สมาชิก UFAEASY888";
    },
    avatarStyle() {
      return this.profile.pictureUrl
        ? { backgroundImage: `url(${this.profile.pictureUrl})` }
        : {};
    },
    depositAmount() {
      return Number((this.status && this.status.depositAmount) || 10);
    },
    receiveTotal() {
      return Number((this.status && this.status.receiveTotal) || 100);
    },
    bonus() {
      return Number((this.status && this.status.bonus) || 90);
    },
    firstDepositQty() {
      const deposit = this.status && this.status.firstDeposit;
      return deposit ? Number(deposit.qty || 0).toLocaleString() : "";
    },
    firstDepositTime() {
      const deposit = this.status && this.status.firstDeposit;
      return deposit && deposit.createdate
        ? deposit.createdate.slice(0, 16)
        : "";
    },
    isBusy() {
      return ["loading", "claiming"].includes(this.state);
    },
    card() {
      const cards = {
        ready: {
          variant: "success",
          title: "พบยอดฝาก 10 บาทแล้ว!",
          message: `ยอดฝาก ${this.firstDepositQty} บาท เมื่อ ${this.firstDepositTime} เข้าเงื่อนไข กดรับเครดิตเพิ่มอีก ${this.bonus} บาทได้เลย`,
          primary: {
            label: `รับ ${this.receiveTotal} เครดิต`,
            action: "claim"
          },
          secondary: null
        },
        "deposit-needed": {
          variant: "info",
          title: "คุณมีสิทธิ์รับโปรนี้",
          message: `ยังไม่มียอดฝากในเดือนกันยายน โอนเข้าบัญชีเว็บ ${this.depositAmount} บาทพอดี (ห้ามมากกว่า) อัปโหลดสลิป แล้วกลับมากดรับเครดิตที่หน้านี้`,
          primary: {
            label: `ไปหน้าฝากเงิน (โอน ${this.depositAmount} บาท)`,
            action: "deposit"
          },
          secondary: { label: "ฝากแล้ว ตรวจสอบอีกครั้ง", action: "reload" }
        },
        "event-upcoming": {
          variant: "info",
          title: "โปรเริ่ม 5 กันยายน",
          message:
            "รับโปรได้วันที่ 5–10 กันยายน 2026 เฉพาะลูกค้าที่ยังไม่ได้ฝากในเดือนกันยายน — อย่าเพิ่งฝากก่อนวันที่ 5 นะคะ",
          primary: null,
          secondary: { label: "ตรวจสอบอีกครั้ง", action: "reload" }
        },
        "event-closed": {
          variant: "warning",
          title: "หมดเวลารับโปรแล้ว",
          message: "โปรคิดถึงนะ รับได้เฉพาะวันที่ 5–10 กันยายน 2026 เท่านั้น",
          primary: null,
          secondary: null
        },
        "not-existing-customer": {
          variant: "warning",
          title: "เฉพาะลูกค้าเก่าเท่านั้น",
          message:
            "โปรนี้สำหรับสมาชิกที่เคยฝากกับเราแล้วและยังไม่ได้ฝากในเดือนกันยายน",
          primary: null,
          secondary: null
        },
        "registered-this-month": {
          variant: "warning",
          title: "เฉพาะสมาชิกที่สมัครก่อน 1 กันยายน",
          message:
            "บัญชีนี้สมัครในเดือนกันยายน จึงไม่เข้าเงื่อนไขโปรคิดถึงนะ (โปรสำหรับลูกค้าเก่าที่ยังไม่ได้ฝากเดือนนี้)",
          primary: null,
          secondary: null
        },
        "phone-already-claimed": {
          variant: "warning",
          title: "เบอร์นี้รับสิทธิ์ไปแล้ว",
          message:
            "เบอร์โทรที่ผูกกับบัญชีนี้ใช้รับโปรคิดถึงนะกับอีกบัญชีแล้ว รับได้คนละ 1 ครั้งเท่านั้น",
          primary: null,
          secondary: null
        },
        "first-deposit-mismatch": {
          variant: "warning",
          title: "ไม่เข้าเงื่อนไข",
          message: `ยอดฝากแรกของเดือนกันยายนคือ ${this.firstDepositQty} บาท (${this.firstDepositTime}) โปรนี้ต้องเป็นยอดฝาก ${this.depositAmount} บาทพอดีและต้องเป็นยอดแรกของเดือน`,
          primary: null,
          secondary: null
        },
        "deposit-before-window": {
          variant: "warning",
          title: "ฝากก่อนวันเริ่มโปร",
          message: `ยอดฝากแรกของเดือนกันยายน (${this.firstDepositTime}) อยู่ก่อนวันที่ 5 กันยายน จึงไม่เข้าเงื่อนไข`,
          primary: null,
          secondary: null
        },
        claiming: {
          variant: "info",
          title: "กำลังบันทึกสิทธิ์...",
          message: "กรุณารอสักครู่ อย่าปิดหน้านี้",
          primary: null,
          secondary: null
        },
        crediting: {
          variant: "info",
          title: "รับสิทธิ์แล้ว กำลังเพิ่มเครดิต",
          message: `ระบบกำลังเพิ่ม ${this.bonus} เครดิตเข้าบัญชี โดยปกติไม่เกิน 1–2 นาที`,
          primary: null,
          secondary: { label: "ตรวจสอบสถานะ", action: "reload" }
        },
        credited: {
          variant: "success",
          title: "เครดิตเข้าแล้ว!",
          message: `เพิ่ม ${this.bonus} เครดิตเข้าบัญชีเรียบร้อย รวมเป็น ${this.receiveTotal} เครดิตจากยอดฝาก ${this.depositAmount} บาท ขอบคุณที่กลับมานะคะ`,
          primary: { label: "เข้าเล่นเลย", action: "play" },
          secondary: null
        },
        "credit-failed": {
          variant: "error",
          title: "เพิ่มเครดิตไม่สำเร็จ",
          message:
            "บันทึกสิทธิ์ของคุณไว้แล้ว แต่ระบบเพิ่มเครดิตขัดข้อง กรุณาแจ้งแอดมินพร้อมรหัสสมาชิกเพื่อรับเครดิต",
          primary: null,
          secondary: { label: "ตรวจสอบอีกครั้ง", action: "reload" }
        },
        "member-error": {
          variant: "error",
          title: "ตรวจสอบสมาชิกไม่ได้",
          message:
            this.detailMessage ||
            "ไม่พบบัญชี UFAEASY888 ที่ผูกกับ LINE นี้ กรุณาติดต่อแอดมิน",
          primary: null,
          secondary: null
        },
        "session-error": {
          variant: "error",
          title: "กรุณาเปิดลิงก์ใหม่",
          message:
            "LIFF session หมดอายุ กรุณาปิดหน้านี้แล้วเปิดลิงก์จาก LINE อีกครั้ง",
          primary: null,
          secondary: { label: "ลองเชื่อมต่ออีกครั้ง", action: "reload" }
        },
        error: {
          variant: "error",
          title: "เกิดข้อผิดพลาด",
          message: this.detailMessage || "กรุณาลองใหม่อีกครั้ง",
          primary: null,
          secondary: { label: "ลองอีกครั้ง", action: "reload" }
        }
      };
      return cards[this.state] || cards.error;
    }
  },
  mounted() {
    document.body.classList.add("miss-you-body");
    this.loadStatus();
  },
  beforeDestroy() {
    this.destroyed = true;
    document.body.classList.remove("miss-you-body");
    this.stopPolling();
  },
  methods: {
    async loadStatus() {
      this.stopPolling();
      this.state = "loading";
      this.detailMessage = "";
      this.accessToken = liffService.getAccessToken() || "";
      if (!this.accessToken) {
        this.state = "session-error";
        return;
      }
      try {
        const status = await getMissYouStatus(this.accessToken);
        if (this.destroyed) return;
        this.applyStatus(status);
      } catch (error) {
        if (!this.destroyed) this.handleStatusError(error);
      }
    },

    applyStatus(status) {
      this.status = status;
      this.claim = status.claim || null;
      if (this.claim) {
        this.applyClaimState(this.claim);
        return;
      }
      if (status.eventStatus === "closed") {
        this.state = "event-closed";
      } else if (status.reason === "registered-this-month") {
        this.state = "registered-this-month";
      } else if (status.reason === "phone-already-claimed") {
        this.state = "phone-already-claimed";
      } else if (status.reason === "not-existing-customer") {
        this.state = "not-existing-customer";
      } else if (status.reason === "no-deposit-yet") {
        this.state =
          status.eventStatus === "upcoming"
            ? "event-upcoming"
            : "deposit-needed";
      } else if (status.reason === "first-deposit-amount-mismatch") {
        this.state = "first-deposit-mismatch";
      } else if (status.reason === "deposit-before-window") {
        this.state = "deposit-before-window";
      } else if (status.eventStatus === "upcoming") {
        this.state = "event-upcoming";
      } else {
        this.state = "ready";
      }
    },

    applyClaimState(claim) {
      const creditStatus = claim.creditStatus || "pending";
      if (creditStatus === "credited") {
        this.state = "credited";
        this.stopPolling();
      } else if (
        creditStatus === "failed" ||
        creditStatus === "dispatch-failed"
      ) {
        this.state = "credit-failed";
        this.stopPolling();
      } else {
        this.state = "crediting";
      }
    },

    async claimReward() {
      if (this.state !== "ready") return;
      this.state = "claiming";
      this.detailMessage = "";
      try {
        const result = await claimMissYouReward(this.accessToken);
        if (this.destroyed) return;
        this.claim = result.claim;
        this.applyClaimState(result.claim);
        if (this.state === "crediting") this.startPolling();
      } catch (error) {
        if (!this.destroyed) this.handleClaimError(error);
      }
    },

    startPolling() {
      this.stopPolling();
      this.pollAttempts = 0;
      this.pollTimer = window.setInterval(this.pollStatus, POLL_INTERVAL_MS);
    },

    stopPolling() {
      if (this.pollTimer) window.clearInterval(this.pollTimer);
      this.pollTimer = null;
    },

    async pollStatus() {
      if (this.destroyed || this.state !== "crediting") {
        this.stopPolling();
        return;
      }
      this.pollAttempts += 1;
      if (this.pollAttempts > POLL_MAX_ATTEMPTS) {
        this.stopPolling();
        return;
      }
      try {
        const status = await getMissYouStatus(this.accessToken);
        if (this.destroyed) return;
        if (status.claim) {
          this.status = status;
          this.claim = status.claim;
          this.applyClaimState(status.claim);
        }
      } catch (error) {
        // Keep polling; the next attempt or a manual refresh will pick it up.
      }
    },

    handleAction(action) {
      if (action === "claim") {
        this.claimReward();
      } else if (action === "deposit") {
        this.$router.push("/deposit");
      } else if (action === "play") {
        this.$router.push("/playlogin");
      } else {
        this.loadStatus();
      }
    },

    handleStatusError(error) {
      const code = this.errorCode(error);
      if (code === "not-found") {
        this.state = "member-error";
      } else if (code === "failed-precondition") {
        this.detailMessage =
          "พบหลายบัญชี UFAEASY888 ที่ใช้ LINE เดียวกัน กรุณาติดต่อแอดมิน";
        this.state = "member-error";
      } else if (code === "unauthenticated" || code === "permission-denied") {
        this.state = "session-error";
      } else {
        this.state = "error";
      }
    },

    handleClaimError(error) {
      const code = this.errorCode(error);
      const reason = this.errorReason(error);
      if (code === "failed-precondition" && reason) {
        // The server re-checked the deposits; refresh so the page shows the exact reason.
        this.loadStatus();
      } else if (code === "unauthenticated" || code === "permission-denied") {
        this.state = "session-error";
      } else if (code === "not-found") {
        this.state = "member-error";
      } else {
        this.detailMessage = "บันทึกสิทธิ์ไม่สำเร็จ กรุณากดลองอีกครั้ง";
        this.state = "error";
      }
    },

    errorCode(error) {
      const rawCode = error && error.code ? String(error.code) : "";
      return rawCode.includes("/") ? rawCode.split("/").pop() : rawCode;
    },

    errorReason(error) {
      return error && error.details && error.details.reason
        ? String(error.details.reason)
        : "";
    },

    closePage() {
      if (liffService.isInClient) {
        liffService.closeWindow();
      } else {
        this.$router.replace("/home");
      }
    }
  }
};
</script>

<template>
  <div class="miss-you-page">
    <div class="page-glow page-glow--one" aria-hidden="true"></div>
    <div class="page-glow page-glow--two" aria-hidden="true"></div>

    <header class="my-header">
      <img
        class="my-header__logo"
        src="../assets/images/logo2.png"
        alt="UFA Easy888"
      />
      <div
        class="my-header__avatar"
        :style="avatarStyle"
        aria-hidden="true"
      ></div>
    </header>

    <main class="my-content">
      <section class="hero">
        <span class="hero__badge">5–10 กันยายน 2026</span>
        <h1 class="hero__title">โปรคิดถึงนะ <em>💛</em></h1>
        <p class="hero__offer">
          ฝาก <strong>{{ depositAmount }}</strong> รับ
          <strong>{{ receiveTotal }}</strong>
        </p>
        <p class="hero__welcome">{{ displayName }} เราคิดถึงคุณนะ</p>
      </section>

      <div v-if="state === 'loading'" class="loading-card" aria-live="polite">
        <span class="loading-card__spinner"></span>
        <strong>กำลังตรวจสอบสิทธิ์</strong>
        <small>กรุณารอสักครู่</small>
      </div>

      <section
        v-else
        class="status-card"
        :class="`status-card--${card.variant}`"
        aria-live="polite"
      >
        <div class="status-card__icon" aria-hidden="true">
          <span v-if="card.variant === 'success'">✓</span>
          <span v-else-if="card.variant === 'warning'">!</span>
          <span v-else-if="card.variant === 'error'">×</span>
          <span v-else>i</span>
        </div>
        <h2 class="status-card__title">{{ card.title }}</h2>
        <p class="status-card__message">{{ card.message }}</p>

        <div v-if="state === 'credited'" class="reward-panel">
          <span class="reward-panel__label">เครดิตที่ได้รับเพิ่ม</span>
          <strong class="reward-panel__value">+{{ bonus }}</strong>
        </div>

        <div class="status-card__actions">
          <button
            v-if="card.primary"
            type="button"
            class="my-button my-button--primary"
            :disabled="isBusy"
            @click="handleAction(card.primary.action)"
          >
            {{ card.primary.label }}
          </button>
          <button
            v-if="card.secondary"
            type="button"
            class="my-button"
            :disabled="isBusy"
            @click="handleAction(card.secondary.action)"
          >
            {{ card.secondary.label }}
          </button>
          <button
            type="button"
            class="my-button my-button--ghost"
            @click="closePage"
          >
            ปิดหน้าต่าง
          </button>
        </div>
      </section>

      <section class="steps">
        <div class="step">
          <span class="step__num">1</span>
          <span>สมัครก่อน 1 ก.ย. และยังไม่ได้ฝากในเดือนกันยายน</span>
        </div>
        <div class="step">
          <span class="step__num">2</span>
          <span
            >โอน {{ depositAmount }} บาทพอดี + ส่งสลิป วันที่ 5–10 ก.ย.</span
          >
        </div>
        <div class="step">
          <span class="step__num">3</span>
          <span>กดรับที่หน้านี้ รับเพิ่ม {{ bonus }} เครดิต</span>
        </div>
      </section>

      <p class="fine-print">
        เฉพาะสมาชิกที่สมัครก่อน 1 ก.ย. และยังไม่มียอดฝากสำเร็จในเดือนกันยายน •
        ยอดฝากแรกของเดือนต้องเป็น {{ depositAmount }} บาทพอดี • รับได้คนละ 1
        ครั้ง (ต่อบัญชีและต่อเบอร์โทร) • รับได้ถึง 10 ก.ย. 23:59 น.
      </p>
    </main>

    <footer class="my-footer">UFAEASY888 • โปรคิดถึงนะ</footer>
  </div>
</template>

<style>
body.miss-you-body {
  min-height: 100vh;
  padding: 0 !important;
  margin: 0;
  background: #1a0710 !important;
  overscroll-behavior: none;
}
</style>

<style scoped>
.miss-you-page {
  position: relative;
  display: flex;
  min-height: 100vh;
  overflow: hidden;
  color: #fff;
  flex-direction: column;
  background: radial-gradient(
      circle at 50% 12%,
      rgba(255, 96, 140, 0.28),
      transparent 40%
    ),
    linear-gradient(180deg, #2a0a1c 0%, #1a0710 55%, #10040a 100%);
  font-family: Kanit, "Sukhumvit Set", -apple-system, BlinkMacSystemFont,
    "Segoe UI", sans-serif;
}
.miss-you-page *,
.miss-you-page *::before,
.miss-you-page *::after {
  box-sizing: border-box;
}

.page-glow {
  position: fixed;
  width: 400px;
  height: 400px;
  pointer-events: none;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.24;
}
.page-glow--one {
  top: -220px;
  left: -160px;
  background: #ff4f8b;
}
.page-glow--two {
  right: -220px;
  bottom: -160px;
  background: #ffb347;
}

.my-header {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: min(100%, 560px);
  min-height: 72px;
  margin: 0 auto;
  padding: max(10px, env(safe-area-inset-top)) 18px 6px;
}
.my-header__logo {
  width: 84px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.32));
}
.my-header__avatar {
  width: 38px;
  height: 38px;
  border: 2px solid rgba(255, 210, 107, 0.72);
  border-radius: 50%;
  background: linear-gradient(135deg, #ff6b9d, #5a1030);
  background-position: center;
  background-size: cover;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.3);
}

.my-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  width: min(100% - 24px, 560px);
  margin: 0 auto;
  padding: 6px 0 24px;
  flex: 1;
  flex-direction: column;
}

.hero {
  margin: 4px 0 14px;
  text-align: center;
}
.hero__badge {
  display: inline-block;
  padding: 4px 12px;
  color: #ffd6e3;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  border: 1px solid rgba(255, 140, 175, 0.4);
  border-radius: 999px;
  background: rgba(255, 79, 139, 0.14);
}
.hero__title {
  margin: 10px 0 0;
  color: #fff3f7;
  font-size: clamp(30px, 9vw, 42px);
  line-height: 1;
  font-weight: 1000;
  letter-spacing: -0.03em;
  text-shadow: 0 0 30px rgba(255, 96, 140, 0.35);
}
.hero__title em {
  font-style: normal;
}
.hero__offer {
  margin: 8px 0 0;
  color: #ffd9a8;
  font-size: 20px;
  font-weight: 700;
}
.hero__offer strong {
  color: #ffb347;
  font-size: 34px;
  font-weight: 1000;
  text-shadow: 0 0 24px rgba(255, 179, 71, 0.4);
}
.hero__welcome {
  margin: 6px 0 0;
  color: #c9a3b3;
  font-size: 13px;
}

.loading-card,
.status-card {
  display: flex;
  align-items: center;
  width: min(100%, 420px);
  padding: 26px 22px 22px;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 26px;
  flex-direction: column;
  background: linear-gradient(
    165deg,
    rgba(60, 16, 38, 0.96),
    rgba(26, 7, 16, 0.98)
  );
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
}
.loading-card__spinner {
  width: 50px;
  height: 50px;
  margin-bottom: 16px;
  border: 4px solid rgba(255, 255, 255, 0.12);
  border-top-color: #ff6b9d;
  border-radius: 50%;
  animation: missYouSpin 0.8s linear infinite;
}
.loading-card strong {
  color: #fff3f7;
  font-size: 18px;
}
.loading-card small {
  margin-top: 6px;
  color: #a98494;
}

.status-card__icon {
  display: grid;
  width: 64px;
  height: 64px;
  margin-bottom: 12px;
  font-size: 30px;
  font-weight: 900;
  border-radius: 50%;
  place-items: center;
  background: rgba(255, 255, 255, 0.08);
}
.status-card--success .status-card__icon {
  color: #1f5c2e;
  background: linear-gradient(135deg, #b8ffcf, #4be08a);
}
.status-card--warning .status-card__icon {
  color: #5a3a00;
  background: linear-gradient(135deg, #ffe9a8, #ffb347);
}
.status-card--error .status-card__icon {
  color: #fff;
  background: linear-gradient(135deg, #ff7b7b, #c62828);
}
.status-card--info .status-card__icon {
  color: #fff;
  background: linear-gradient(135deg, #ff8fb6, #ff4f8b);
}
.status-card__title {
  margin: 0;
  color: #fff3f7;
  font-size: 21px;
  font-weight: 900;
}
.status-card__message {
  margin: 8px 0 0;
  color: #d9b8c6;
  font-size: 13.5px;
  line-height: 1.55;
}

.reward-panel {
  width: 100%;
  margin-top: 16px;
  padding: 14px;
  border-radius: 18px;
  background: rgba(255, 179, 71, 0.1);
  border: 1px solid rgba(255, 179, 71, 0.3);
}
.reward-panel__label {
  display: block;
  color: #ffd9a8;
  font-size: 12px;
}
.reward-panel__value {
  display: block;
  color: #ffb347;
  font-size: 40px;
  line-height: 1.1;
  font-weight: 1000;
}

.status-card__actions {
  display: flex;
  width: 100%;
  margin-top: 18px;
  gap: 10px;
  flex-direction: column;
}
.my-button {
  width: 100%;
  min-height: 50px;
  padding: 10px 18px;
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.07);
  cursor: pointer;
}
.my-button--primary {
  min-height: 58px;
  color: #3a0c1f;
  font-size: 19px;
  font-weight: 1000;
  border: 0;
  background: linear-gradient(135deg, #ffe176, #ffb347 55%, #ff6b9d);
  box-shadow: 0 14px 36px rgba(255, 107, 157, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
}
.my-button--ghost {
  min-height: 42px;
  color: #b58ea0;
  font-size: 14px;
  font-weight: 600;
  border-color: transparent;
  background: transparent;
}
.my-button:disabled {
  opacity: 0.55;
  cursor: default;
}
.my-button:active:not(:disabled) {
  transform: translateY(1px) scale(0.99);
}

.steps {
  display: flex;
  width: min(100%, 420px);
  margin-top: 16px;
  gap: 8px;
  flex-direction: column;
}
.step {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  color: #e6c9d6;
  font-size: 13px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.05);
}
.step__num {
  display: grid;
  width: 26px;
  height: 26px;
  color: #3a0c1f;
  font-size: 13px;
  font-weight: 900;
  border-radius: 50%;
  place-items: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, #ffe176, #ffb347);
}
.fine-print {
  width: min(100%, 420px);
  margin: 12px 0 0;
  color: #7d5f6c;
  font-size: 10.5px;
  line-height: 1.5;
  text-align: center;
}
.my-footer {
  position: relative;
  z-index: 2;
  padding: 7px 12px max(12px, env(safe-area-inset-bottom));
  color: #5a3f4b;
  font-size: 9px;
  text-align: center;
  letter-spacing: 0.2em;
}

@keyframes missYouSpin {
  to {
    transform: rotate(360deg);
  }
}
</style>
